/* eslint-disable frontApplet/enforce-jsdoc */
import ILoadFileController from './ILoadFileController';

export default class JavascriptLoadFileController implements ILoadFileController {
	public readonly name: string = 'javascript';

	constructor(private window: Window) {}

	public load(filePath: string, element: HTMLElement) {
		return new Promise<void>((resolve: () => void, reject: (error: Error) => void) => {
			const scriptTag = this.window.document.createElement('script');
			scriptTag.setAttribute('type', 'text/javascript');
			scriptTag.setAttribute('src', filePath);
			scriptTag.onerror = () => {
				reject(new Error('File "' + filePath + '" cannot be loaded'));
			};
			scriptTag.onload = () => {
				console.info('File ' + filePath.substring(0, 100) + ' was loaded');
				resolve();
			};
			element.appendChild(scriptTag);
		});
	}
}
